// extracted by mini-css-extract-plugin
export default {"pageContainer":"styles_pageContainer__4nWLl","pageGrid":"styles_pageGrid__kK1jv","header":"styles_header__K1PKa","meetingsRoomsPageGrid":"styles_meetingsRoomsPageGrid__BmN7j"};